module.exports = __webpack_public_path__ + "img/campanaSolidariaFondo.bd290299.jpg";